(function () {
  'use strict';

  function initEhPage() {
    initMaterialIconsReady();
    initSmoothAnchors();
    initFaq();
    initButtons();
    initNavScroll();
    initProofSlider();
    initCardSliders();
    initLazyMaps();
  }

  function initLazyMaps() {
    document.querySelectorAll('[data-eh-map-lazy]').forEach(function (wrap) {
      if (wrap.dataset.ehMapBound === 'true') return;
      wrap.dataset.ehMapBound = 'true';

      var template = wrap.querySelector('template[data-eh-map-template]');
      var slot = wrap.querySelector('[data-eh-map-slot]');
      var placeholder = wrap.querySelector('[data-eh-map-placeholder]');
      if (!template || !slot) return;

      var loaded = false;
      function loadMap() {
        if (loaded) return;
        loaded = true;
        slot.innerHTML = template.innerHTML;
        slot.hidden = false;
        if (placeholder) placeholder.hidden = true;
        var iframe = slot.querySelector('iframe');
        if (iframe && !iframe.getAttribute('loading')) {
          iframe.setAttribute('loading', 'lazy');
        }
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              loadMap();
              observer.disconnect();
            });
          },
          { rootMargin: '280px 0px', threshold: 0.01 }
        );
        observer.observe(wrap);
      } else {
        loadMap();
      }
    });
  }

  function initMaterialIconsReady() {
    function markIconsReady() {
      document.documentElement.classList.add('primo-icons-ready');
    }

    if (document.documentElement.classList.contains('primo-icons-ready')) return;

    if (document.fonts && document.fonts.load) {
      document.fonts
        .load('24px "Material Symbols Outlined"')
        .then(markIconsReady)
        .catch(markIconsReady);
      setTimeout(markIconsReady, 2500);
    } else {
      markIconsReady();
    }
  }

  function initProofSlider() {
    document.querySelectorAll('[data-eh-proof-slider]').forEach(function (slider) {
      if (slider.dataset.ehProofBound === 'true') return;
      slider.dataset.ehProofBound = 'true';
      var track = slider.querySelector('[data-eh-proof-track]');
      var prev = slider.querySelector('[data-eh-proof-prev]');
      var next = slider.querySelector('[data-eh-proof-next]');
      if (!track) return;

      function scrollBySlide(direction) {
        var slide = track.querySelector('img');
        var amount = slide ? slide.getBoundingClientRect().width + 12 : 280;
        track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }

      function updateNavState() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = maxScroll <= 2 || track.scrollLeft >= maxScroll - 2;
        slider.classList.toggle('is-at-end', maxScroll <= 2 || track.scrollLeft >= maxScroll - 2);
      }

      if (prev) prev.addEventListener('click', function () { scrollBySlide(-1); });
      if (next) next.addEventListener('click', function () { scrollBySlide(1); });
      track.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      updateNavState();
    });
  }

  function initCardSliders() {
    document.querySelectorAll('[data-eh-card-slider]').forEach(function (slider) {
      if (slider.dataset.ehCardSliderBound === 'true') return;
      slider.dataset.ehCardSliderBound = 'true';
      var track = slider.querySelector('[data-eh-card-track]');
      var prev = slider.querySelector('[data-eh-card-prev]');
      var next = slider.querySelector('[data-eh-card-next]');
      if (!track) return;

      var slideSelector = slider.getAttribute('data-eh-card-slide') || ':scope > *';
      var gap = parseInt(slider.getAttribute('data-eh-card-gap') || '14', 10);

      function getTrackGap() {
        var style = window.getComputedStyle(track);
        return parseInt(style.columnGap || style.gap, 10) || gap;
      }

      function scrollBySlide(direction) {
        var slide = track.querySelector(slideSelector);
        var amount = slide ? slide.getBoundingClientRect().width + getTrackGap() : 280;
        track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }

      function updateNavState() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = maxScroll <= 2 || track.scrollLeft >= maxScroll - 2;
        slider.classList.toggle('is-at-end', maxScroll <= 2 || track.scrollLeft >= maxScroll - 2);
      }

      if (prev) prev.addEventListener('click', function () { scrollBySlide(-1); });
      if (next) next.addEventListener('click', function () { scrollBySlide(1); });
      track.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      updateNavState();
    });
  }

  function initNavScroll() {
    var nav = document.getElementById('primo-eh-nav');
    var hero = document.getElementById('primo-eh-hero');
    if (!nav || !nav.classList.contains('primo-eh-nav--over-hero')) return;

    function updateNav() {
      var threshold = hero ? hero.offsetHeight - nav.offsetHeight - 24 : 80;
      nav.classList.toggle('is-scrolled', window.scrollY > threshold);
    }

    updateNav();
    window.addEventListener('scroll', updateNav, { passive: true });
  }

  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      if (anchor.dataset.ehAnchorBound === 'true') return;
      anchor.dataset.ehAnchorBound = 'true';
      anchor.addEventListener('click', function (e) {
        var id = anchor.getAttribute('href');
        if (!id || id === '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        highlightHeroForm();
      });
    });
  }

  function highlightHeroForm() {
    var formCard = document.querySelector('.primo-eh-hero__form-card--ivory');
    if (!formCard) return;
    formCard.classList.add('is-form-focus');
    window.setTimeout(function () {
      formCard.classList.remove('is-form-focus');
    }, 1400);
    var firstField = formCard.querySelector('input, select, textarea');
    if (firstField && window.matchMedia('(max-width: 899px)').matches) {
      window.setTimeout(function () {
        firstField.focus({ preventScroll: true });
      }, 450);
    }
  }

  function initFaq() {
    document.querySelectorAll('.primo-eh-faq__trigger').forEach(function (trigger) {
      if (trigger.dataset.ehFaqBound === 'true') return;
      trigger.dataset.ehFaqBound = 'true';
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        document.querySelectorAll('.primo-eh-faq__trigger').forEach(function (other) {
          if (other === trigger) return;
          other.setAttribute('aria-expanded', 'false');
          var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          if (otherPanel) otherPanel.hidden = true;
        });
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) panel.hidden = expanded;
      });
    });
  }

  function initButtons() {
    document.querySelectorAll('.template-consultation .primo-btn').forEach(function (button) {
      if (button.dataset.ehBtnBound === 'true') return;
      button.dataset.ehBtnBound = 'true';
      button.addEventListener('mousedown', function () {
        button.classList.add('is-pressed');
      });
      ['mouseup', 'mouseleave'].forEach(function (evt) {
        button.addEventListener(evt, function () {
          button.classList.remove('is-pressed');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEhPage);
  } else {
    initEhPage();
  }

  document.addEventListener('shopify:section:load', initEhPage);
})();
